import { useState, useEffect } from 'react'
import { Tooltip } from 'antd'
import Text from '../Text/Text'
import buildInfo from '~/build-info.json'

const VersionDisplay = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [backendInfo, setBackendInfo] = useState({
    version: 'Loading...',
    gitTag: 'Loading...',
    buildTime: 'Loading...',
    environment: 'Loading...',
  })

  useEffect(() => {
    const fetchBackendInfo = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/api/app/health-check`)
        const data = await response.json()
        setBackendInfo({
          version: data.version || 'Unknown',
          gitTag: data.gitTag || 'Unknown',
          buildTime: data.buildTime || 'Unknown',
          environment: data.environment || 'Unknown',
        })
      } catch (error) {
        setBackendInfo({
          version: 'Unavailable',
          gitTag: 'Unavailable',
          buildTime: 'Unavailable',
          environment: 'Unavailable',
        })
      }
    }
    fetchBackendInfo()
  }, [])

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <Tooltip
        title={isExpanded ? 'Click to collapse' : 'Click for build details'}
        placement="topRight"
      >
        <div
          onClick={() => setIsExpanded(!isExpanded)}
          className={`
            bg-white border border-grey-200 rounded-lg shadow-lg cursor-pointer
            transition-all duration-300 ease-in-out
            ${isExpanded ? 'p-4 min-w-[280px]' : 'px-3 py-1'}
            hover:shadow-xl
          `}
        >
          {isExpanded ? (
            <div className="space-y-3">
              <Text className="font-semibold text-grey-800">Build Information</Text>

              {/* Frontend Section */}
              <div className="space-y-1">
                <Text className="font-medium text-grey-700 text-sm">Frontend Build Info</Text>
                <div className="space-y-1 text-xs pl-2">
                  <div className="flex justify-between">
                    <span className="text-grey-600">Version:</span>
                    <span className="font-mono font-semibold text-blue-600">
                      {buildInfo.version}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-grey-600">Git Tag:</span>
                    <span className="font-mono text-xs">{buildInfo.tag}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-grey-600">Commit:</span>
                    <span className="font-mono text-xs">{buildInfo.commit}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-grey-600">Build Date:</span>
                    <span className="font-mono text-xs">
                      {new Date(buildInfo.buildDate).toLocaleDateString()}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-grey-600">Environment:</span>
                    <span className="font-mono">{buildInfo.environment}</span>
                  </div>
                </div>
              </div>

              {/* Backend Section */}
              <div className="space-y-1">
                <Text className="font-medium text-grey-700 text-sm">Backend Build Info</Text>
                <div className="space-y-1 text-xs pl-2">
                  <div className="flex justify-between">
                    <span className="text-grey-600">Version:</span>
                    <span className="font-mono">{backendInfo.version}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-grey-600">Tag:</span>
                    <span className="font-mono text-xs">{backendInfo.gitTag}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-grey-600">Build:</span>
                    <span className="font-mono text-xs">
                      {backendInfo.buildTime !== 'Loading...' &&
                      backendInfo.buildTime !== 'Unknown' &&
                      backendInfo.buildTime !== 'Unavailable'
                        ? new Date(backendInfo.buildTime).toLocaleDateString()
                        : backendInfo.buildTime}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-grey-600">Env:</span>
                    <span className="font-mono">{backendInfo.environment}</span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-1">
              <span className="text-xs text-grey-500">v</span>
              <Text className="text-xs font-semibold text-grey-700 font-mono">{buildInfo.version}</Text>
            </div>
          )}
        </div>
      </Tooltip>
    </div>
  )
}

export default VersionDisplay
